import { IAppState } from '../../common/state';

export function getIsFlatTourBookingTooltipVisible(state: IAppState): boolean {
  const { newbuildingFlatTourBookingTooltipVisible } = state;

  return newbuildingFlatTourBookingTooltipVisible;
}
